import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import { BlockQuoteElement } from '@src/components/sco/RichMarkdownInput/components/elements/BlockQuoteElement';
import { LinkElement } from '@src/components/sco/RichMarkdownInput/components/elements/LinkElement';
import { ListItemElement } from '@src/components/sco/RichMarkdownInput/components/elements/ListItemElement';
import { MentionElement, MentionElementProps } from '@src/components/sco/RichMarkdownInput/components/elements/MentionElement';
import { OrderedListElement } from '@src/components/sco/RichMarkdownInput/components/elements/OrderedListElement';
import { ParagraphElement } from '@src/components/sco/RichMarkdownInput/components/elements/ParagraphElement';
import { RawMarkdownElement, RawMarkdownElementType } from '@src/components/sco/RichMarkdownInput/components/elements/RawMarkdownElement';
import { UnorderedListElement } from '@src/components/sco/RichMarkdownInput/components/elements/UnorderedListElement';
import React from 'react';
import { RenderElementProps } from 'slate-react';
export enum EditorElementTypes {
  BLOCK_QUOTE = 'block_quote',
  CODE_BLOCK = 'code_block',
  HEADING_FIVE = 'heading_five',
  HEADING_FOUR = 'heading_four',
  HEADING_ONE = 'heading_one',
  HEADING_SIX = 'heading_six',
  HEADING_THREE = 'heading_three',
  HEADING_TWO = 'heading_two',
  IMAGE = 'image',
  LINK = 'link',
  LIST_ITEM = 'list_item',
  LIST_ITEM_TEXT = 'list_item_text',
  MENTION = 'mention',
  OL_LIST = 'ol_list',
  PARAGRAPH = 'paragraph',
  RAW_MARKDOWN = 'raw_markdown',
  THEMATIC_BREAK = 'thematic_break',
  UL_LIST = 'ul_list',
}
export const Element = props => {
  const $ = _c(51);
  switch (props.type || props.element.type) {
    case EditorElementTypes.LINK:
      {
        const t0 = props as any;
        let t1;
        if ($[0] !== props.children || $[1] !== t0) {
          t1 = <LinkElement {...t0}>{props.children}</LinkElement>;
          $[0] = props.children;
          $[1] = t0;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case EditorElementTypes.BLOCK_QUOTE:
      {
        let t0;
        if ($[3] !== props) {
          t0 = <BlockQuoteElement {...props}>{props.children}</BlockQuoteElement>;
          $[3] = props;
          $[4] = t0;
        } else {
          t0 = $[4];
        }
        return t0;
      }
    case EditorElementTypes.LIST_ITEM:
      {
        let t0;
        if ($[5] !== props) {
          t0 = <ListItemElement {...props}>{props.children}</ListItemElement>;
          $[5] = props;
          $[6] = t0;
        } else {
          t0 = $[6];
        }
        return t0;
      }
    case EditorElementTypes.LIST_ITEM_TEXT:
      {
        let t0;
        if ($[7] !== props.children) {
          t0 = <>{props.children}</>;
          $[7] = props.children;
          $[8] = t0;
        } else {
          t0 = $[8];
        }
        return t0;
      }
    case EditorElementTypes.OL_LIST:
      {
        let t0;
        if ($[9] !== props) {
          t0 = <OrderedListElement {...props}>{props.children}</OrderedListElement>;
          $[9] = props;
          $[10] = t0;
        } else {
          t0 = $[10];
        }
        return t0;
      }
    case EditorElementTypes.UL_LIST:
      {
        let t0;
        if ($[11] !== props) {
          t0 = <UnorderedListElement {...props}>{props.children}</UnorderedListElement>;
          $[11] = props;
          $[12] = t0;
        } else {
          t0 = $[12];
        }
        return t0;
      }
    case EditorElementTypes.MENTION:
      {
        const t0 = props as MentionElementProps;
        let t1;
        if ($[13] !== props.children || $[14] !== t0) {
          t1 = <MentionElement {...t0}>{props.children}</MentionElement>;
          $[13] = props.children;
          $[14] = t0;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case EditorElementTypes.HEADING_ONE:
      {
        let t0;
        if ($[16] !== props.attributes || $[17] !== props.children) {
          t0 = <h1 {...props.attributes}>{props.children}</h1>;
          $[16] = props.attributes;
          $[17] = props.children;
          $[18] = t0;
        } else {
          t0 = $[18];
        }
        return t0;
      }
    case EditorElementTypes.HEADING_TWO:
      {
        let t0;
        if ($[19] !== props.attributes || $[20] !== props.children) {
          t0 = <h2 {...props.attributes}>{props.children}</h2>;
          $[19] = props.attributes;
          $[20] = props.children;
          $[21] = t0;
        } else {
          t0 = $[21];
        }
        return t0;
      }
    case EditorElementTypes.HEADING_THREE:
      {
        let t0;
        if ($[22] !== props.attributes || $[23] !== props.children) {
          t0 = <h3 {...props.attributes}>{props.children}</h3>;
          $[22] = props.attributes;
          $[23] = props.children;
          $[24] = t0;
        } else {
          t0 = $[24];
        }
        return t0;
      }
    case EditorElementTypes.HEADING_FOUR:
      {
        let t0;
        if ($[25] !== props.attributes || $[26] !== props.children) {
          t0 = <h4 {...props.attributes}>{props.children}</h4>;
          $[25] = props.attributes;
          $[26] = props.children;
          $[27] = t0;
        } else {
          t0 = $[27];
        }
        return t0;
      }
    case EditorElementTypes.HEADING_FIVE:
      {
        let t0;
        if ($[28] !== props.attributes || $[29] !== props.children) {
          t0 = <h5 {...props.attributes}>{props.children}</h5>;
          $[28] = props.attributes;
          $[29] = props.children;
          $[30] = t0;
        } else {
          t0 = $[30];
        }
        return t0;
      }
    case EditorElementTypes.HEADING_SIX:
      {
        let t0;
        if ($[31] !== props.attributes || $[32] !== props.children) {
          t0 = <h6 {...props.attributes}>{props.children}</h6>;
          $[31] = props.attributes;
          $[32] = props.children;
          $[33] = t0;
        } else {
          t0 = $[33];
        }
        return t0;
      }
    case EditorElementTypes.THEMATIC_BREAK:
      {
        let t0;
        if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
          t0 = {
            margin: "1em 0"
          };
          $[34] = t0;
        } else {
          t0 = $[34];
        }
        let t1;
        if ($[35] !== props.attributes) {
          t1 = <hr {...props.attributes} style={t0} />;
          $[35] = props.attributes;
          $[36] = t1;
        } else {
          t1 = $[36];
        }
        return t1;
      }
    case EditorElementTypes.IMAGE:
      {
        let t0;
        if ($[37] !== props.attributes || $[38] !== props.element.caption || $[39] !== props.element.link) {
          t0 = <img {...props.attributes} alt={props.element.caption} src={props.element.link} />;
          $[37] = props.attributes;
          $[38] = props.element.caption;
          $[39] = props.element.link;
          $[40] = t0;
        } else {
          t0 = $[40];
        }
        return t0;
      }
    case EditorElementTypes.CODE_BLOCK:
      {
        let t0;
        if ($[41] !== props.attributes || $[42] !== props.children) {
          t0 = <chakra.code {...props.attributes} backgroundColor="gray.700" borderRadius="3px" display="block" fontSize="90%" margin="3px 0" padding="3px">{props.children}</chakra.code>;
          $[41] = props.attributes;
          $[42] = props.children;
          $[43] = t0;
        } else {
          t0 = $[43];
        }
        return t0;
      }
    case EditorElementTypes.RAW_MARKDOWN:
      {
        const t0 = props.element as RawMarkdownElementType;
        let t1;
        if ($[44] !== props || $[45] !== t0) {
          t1 = <RawMarkdownElement {...props} element={t0} />;
          $[44] = props;
          $[45] = t0;
          $[46] = t1;
        } else {
          t1 = $[46];
        }
        return t1;
      }
    case EditorElementTypes.PARAGRAPH:
      {
        let t0;
        if ($[47] !== props) {
          t0 = <ParagraphElement {...props}>{props.children}</ParagraphElement>;
          $[47] = props;
          $[48] = t0;
        } else {
          t0 = $[48];
        }
        return t0;
      }
    default:
      {
        let t0;
        if ($[49] !== props) {
          t0 = <span {...props}>{props.children}</span>;
          $[49] = props;
          $[50] = t0;
        } else {
          t0 = $[50];
        }
        return t0;
      }
  }
};